/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgInboxAdd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12.005 5v2H7.236l-3.231 5H8.54l2 3h2.93l2-3h6.517l.018 1.02V22h-20l-.001-9.37a10.96 10.96 0 0 1 0-.586v-.025L2.006 12 6.11 5.553c.17-.339.516-.553.895-.553zM7.47 14H4.005v6h16v-6H16.54l-2 3H9.47zM19.005 2v3h3v2h-3v3h-2V7h-3V5h3V2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgInboxAdd as InboxAdd };
